import {
  CreateKpiBodySchema,
  UpdateKpiBodySchema,
  ReorderKpisBodySchema,
  KpiCatalogEntrySchema,
  KpiCatalogResponseSchema,
  TenantDefaultNorthStarSchema,
  TenantDashboardCardsSchema,
  type TenantDashboardCards,
  type CreateKpiBody,
  type UpdateKpiBody,
  type KpiCatalogEntry,
  type TenantDefaultNorthStar,
} from "@nexus/contracts";
import { authFetch } from "@/lib/api-client";

function tenantHeaders(tenantId: string): Record<string, string> {
  return { "X-Tenant-Id": tenantId };
}

export async function createTenantKpi(tenantId: string, body: CreateKpiBody): Promise<KpiCatalogEntry> {
  const payload = CreateKpiBodySchema.parse(body);
  const { data } = await authFetch<KpiCatalogEntry>("/tenant-kpis", {
    method: "POST",
    headers: tenantHeaders(tenantId),
    body: JSON.stringify(payload),
  });
  return KpiCatalogEntrySchema.parse(data);
}

export async function updateTenantKpi(
  tenantId: string,
  id: number,
  body: UpdateKpiBody,
): Promise<KpiCatalogEntry> {
  const payload = UpdateKpiBodySchema.parse(body);
  const { data } = await authFetch<KpiCatalogEntry>(`/tenant-kpis/${id}`, {
    method: "PATCH",
    headers: tenantHeaders(tenantId),
    body: JSON.stringify(payload),
  });
  return KpiCatalogEntrySchema.parse(data);
}

export async function deleteTenantKpi(tenantId: string, id: number): Promise<void> {
  await authFetch(`/tenant-kpis/${id}`, {
    method: "DELETE",
    headers: tenantHeaders(tenantId),
  });
}

export async function updateTenantDashboardCards(
  tenantId: string,
  body: TenantDashboardCards,
): Promise<TenantDashboardCards> {
  const payload = TenantDashboardCardsSchema.parse(body);
  const { data } = await authFetch<TenantDashboardCards>("/tenant-kpis/dashboard-cards", {
    method: "PUT",
    headers: tenantHeaders(tenantId),
    body: JSON.stringify(payload),
  });
  return TenantDashboardCardsSchema.parse(data);
}

export async function updateTenantDefaultNorthStar(
  tenantId: string,
  body: TenantDefaultNorthStar,
): Promise<TenantDefaultNorthStar> {
  const payload = TenantDefaultNorthStarSchema.parse(body);
  const { data } = await authFetch<TenantDefaultNorthStar>("/tenant-kpis/default-north-star", {
    method: "PUT",
    headers: tenantHeaders(tenantId),
    body: JSON.stringify(payload),
  });
  return TenantDefaultNorthStarSchema.parse(data);
}

export async function reorderTenantKpis(tenantId: string, names: string[]): Promise<KpiCatalogEntry[]> {
  const payload = ReorderKpisBodySchema.parse({ names });
  const { data } = await authFetch<KpiCatalogEntry[]>("/tenant-kpis/order", {
    method: "PUT",
    headers: tenantHeaders(tenantId),
    body: JSON.stringify(payload),
  });
  return KpiCatalogResponseSchema.parse(data);
}
